module.exports = __webpack_public_path__ + "img/home_testimonial3.e26bfc9.png";